import { render, staticRenderFns } from "./CompanyAdder.vue?vue&type=template&id=417e7e68&"
import script from "./CompanyAdder.vue?vue&type=script&lang=js&"
export * from "./CompanyAdder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports